import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=796f8c1a&"
import script from "./Artist.vue?vue&type=script&lang=js&"
export * from "./Artist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports